// Preserve address-level classification; never assume every destination is commercial.
export function upsDestinationDetails(address: any) {
  const nested = address?.address_details || address || {};
  const company = [nested.company_name, nested.companyName, nested.company,
    address?.company_name, address?.companyName, address?.company]
    .find(value => typeof value === "string" && value.trim());
  const residential = [nested.is_residential, nested.isResidential,
    address?.is_residential, address?.isResidential]
    .find(value => typeof value === "boolean");
  return {
    ...(company ? { company_name: company.trim() } : {}),
    ...(typeof residential === "boolean" ? { is_residential: residential } : {}),
  };
}
